<template>

    <div class="orders">
        <h2>{{ lang('all.mijn_bestellingen') }}</h2>

        <table class="table table-striped table-hover">
            <thead>
                <tr>
                    <th class="col-2">{{ lang('all.bestelnummer') }}</th>
                    <th class="col-4">{{ lang('all.datum') }}</th>
                    <th class="col-2">{{ lang('all.status') }}</th>
                    <th class="text-right">{{ lang('all.totaalbedrag') }}</th>
                    <th>&nbsp;</th>
                </tr>
            </thead>
            <tbody>
                <tr
                    v-if="orders.data.length === 0"
                >
                    <td colspan="5">{{ lang('all.er_zijn_geen_bestellingen_gevonden') }}</td>
                </tr>
                <tr
                    v-for="order in orders.data"
                >
                    <td class="align-middle">#{{ order.number }}</td>
                    <td class="align-middle">{{ order.date | formatDate }}</td>
                    <td class="align-middle">{{ order.status }}</td>
                    <td class="align-middle text-right">{{ order.totalamount | toCurrency }}</td>
                    <td class="text-right">
                        <inertia-link
                            :href="route('auth.myaccount.orders.show', {uuid: order.uuid})"
                            v-tooltip="lang('all.bestelling_bekijken')"
                            class="btn btn-primary btn-sm mb-0"
                        >
                            <i class="mdi mdi-truck-cargo-container"></i>
                            <span class="sr-only">
                                {{ lang('all.bestelling_bekijken') }}
                            </span>
                        </inertia-link>
                    </td>
                </tr>
            </tbody>
        </table>

        <div
            v-if="failedorders.data.length > 0"
            class="mt-5"
        >
            <h2>{{ lang('all.mislukte_bestellingen') }}</h2>

            <table class="table table-striped table-hover">
                <thead>
                    <tr>
                        <th class="col-2">{{ lang('all.bestelnummer') }}</th>
                        <th class="col-4">{{ lang('all.datum') }}</th>
                        <th class="col-2">{{ lang('all.status') }}</th>
                        <th class="text-right">{{ lang('all.totaalbedrag') }}</th>
                        <th>&nbsp;</th>
                    </tr>
                </thead>
                <tbody>
                    <tr
                        v-for="order in failedorders.data"
                    >
                        <td class="align-middle">#{{ order.number }}</td>
                        <td class="align-middle">{{ order.date | formatDate }}</td>
                        <td class="align-middle">{{ order.status }}</td>
                        <td class="align-middle text-right">{{ order.totalamount | toCurrency }}</td>
                        <td class="text-right">
                            <inertia-link
                                :href="route('auth.myaccount.orders.show', {uuid: order.uuid})"
                                v-tooltip="lang('all.bestelling_bekijken')"
                                class="btn btn-primary btn-sm mb-0"
                            >
                                <i class="mdi mdi-truck-cargo-container"></i>
                                <span class="sr-only">
                                {{ lang('all.bestelling_bekijken') }}
                            </span>
                            </inertia-link>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

</template>

<script>

import MyAccountLayout from "../../../../Shared/Auth/MyAccount/Layout";

export default {

    layout:MyAccountLayout,

    metaInfo: {
        title: 'Mijn bestellingen'
    },

    name:'AuthMyAccountOrdersIndex',

    props: {
        failedorders: {
            required:true,
            type:Object,
        },
        orders: {
            required:true,
            type:Object,
        },
    },

}

</script>
